<template>
    <dashboard-layout>
        <v-container fluid class="down-top-padding py-0">
            <BaseBreadcrumb
            :title="page.title"
            :icon="page.icon"
            :breadcrumbs="breadcrumbs"
            ></BaseBreadcrumb>
            <v-row dense>
                <v-col cols="12">
                    <table-system-order-status></table-system-order-status>
                </v-col>
            </v-row>
        </v-container>
    </dashboard-layout>
</template>

<script>
import DashboardLayout from '@/Layouts/DashboardLayout.vue'
import BaseBreadcrumb from '@/components/BaseBreadcrumb.vue'
import TableSystemOrderStatus from './TableGrids/TableSystemOrderStatus.vue'

export default {
    name: 'SystemOrderStatus',
    props: {

    },
    components: {
        DashboardLayout,
        BaseBreadcrumb,
        TableSystemOrderStatus,
    },
    data() {
        return {
            page: {
                title: "Order Status",
            },
            breadcrumbs: [
                { text: "Order Status", disabled: true },
            ],
        }
    },
    watch: {},
    computed: {},
    mounted: function () {},
    methods: {

    }
}
</script>
